var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomplaylist(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1494_344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.625 10.9314C9.625 12.6236 11.0014 14 12.6936 14C14.3859 14 15.7622 12.6236 15.7622 10.9314C15.7622 10.7765 15.7386 10.6277 15.7159 10.479H15.75V1.75H17.5V0H14.875C14.6429 0 14.4204 0.0921874 14.2563 0.256282C14.0922 0.420376 14 0.642936 14 0.875V8.16638C13.5926 7.96921 13.1462 7.86577 12.6936 7.86363C11.8801 7.86432 11.1002 8.18772 10.5249 8.76286C9.94955 9.338 9.62593 10.1179 9.625 10.9314V10.9314ZM0 0.875H12.25V2.625H0V0.875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 4.375H12.25V6.125H0V4.375ZM0 7.875H7.875V9.625H0V7.875ZM0 11.375H7.875V13.125H0V11.375Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1494_344"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.5,
    height: 14,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomplaylist);
export default __webpack_public_path__ + "static/media/customplaylist.00bab83ee2f9c95b5a03c9dec43122db.svg";
export { ForwardRef as ReactComponent };